export interface FetchSummaryParams {
    sourceData: unknown;
    searchInput: string;
}

export async function fetchSummary({ sourceData, searchInput }: FetchSummaryParams): Promise<string> {
    const prompt = `
    Here’s the source data:
    ${JSON.stringify(sourceData, null, 2)}

    Compare this to: "${searchInput}"
    Summarize what the user is likely looking for and describe the related content.
    `;

    try {
        const res = await fetch("/api/analyze", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                prompt,
                config: {
                    temperature: 0.7,
                    topK: 40,
                    topP: 0.95,
                    maxOutputTokens: 512,
                },
            }),
        });

        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

        const data = await res.json();
        return data?.text ?? "No summary available.";
    } catch (err) {
        console.error("❌ fetchSummary error:", err);
        throw new Error("Failed to fetch summary.");
    }
}
